import { NavLink } from 'react-router-dom';
import { LogoExamsReactor, ThemeToggle, cn } from '@examsreactor/ui';

const navItems = [
  { label: 'Certificaciones', to: '/certificaciones' },
  { label: 'Precios', to: '/precios' },
];

export function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-border-subtle bg-bg-primary/80 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <NavLink to="/" aria-label="ExamsReactor home" className="flex items-center">
          <LogoExamsReactor variant="full" size="md" />
        </NavLink>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Navegacion principal">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-bg-secondary text-text-primary'
                    : 'text-text-secondary hover:bg-bg-secondary hover:text-text-primary',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <a href="/login" className="btn-ghost hidden sm:inline-flex">
            Iniciar sesion
          </a>
          <a href="/registro" className="btn-primary">
            Probar gratis
          </a>
        </div>
      </div>
    </header>
  );
}
